<template>
    <section class="section">
        <div class="section__header">
            <h3 class="section__title">{{ getTranslation('testingQuestions') }} - {{questions.length}}</h3>
            <div class="section__controls">
                <div class="section__controls-group">
                    <router-link v-if="hasPermission('api.question.create')" :to="{ name: 'api.question.create', query: { testingId: testingId} }" class="btn  btn--white  btn--system  btn--with-icon">
                        <svg class="btn__icon">
                            <use xlink:href="#icon__square-add"></use>
                        </svg>
                        {{ getTranslation('addQuestion') }}
                    </router-link>
                    <a v-if="hasPermission('api.testing.profile.importQuestions')" @click="openImportModal" class="btn  btn--white  btn--system  btn--with-icon" href="javascript:void(0)">
                        <svg class="btn__icon">
                            <use xlink:href="#icon__file-text"></use>
                        </svg>
                        {{ getTranslation('importQuestions') }}
                    </a>
                </div>
            </div>
        </div>
        <div class="section__body">
            <table class="table-3 table-borderless">
                <thead class="table-3__head">
                    <tr class="table-3__row">
                        <td class="table-3__cell  table__hcell">
                            <p class="section__descr">{{getTranslation('search')}}</p>
                        </td>
                        <td class="table-3__cell  table__hcell">
                            <form @submit.prevent="fetchTestingQuestions(testingId)">
                                <input v-model="filterForm.questionId" type="text" class="form-control" :placeholder="getTranslation('questionID')" />
                            </form>
                        </td>
                        <td colspan="2" class="table-3__cell  table__hcell">
                            <form @submit.prevent="fetchTestingQuestions(testingId)">
                                <input v-model="filterForm.query" type="text" class="form-control" :placeholder="getTranslation('title')" />
                            </form>
                        </td>
                        <td class="table-3__cell  table__hcell">
                            <v-select
                                    :options="types"
                                    label="title"
                                    v-model="filterForm.typeId"
                                    :reduce="option=>option.id"
                                    :placeholder="getTranslation('selectFromList')"
                            />
                        </td>
                        <td class="table-3__cell  table__hcell">
                            <v-select
                                    v-model="filterForm.status"
                                    label="title"
                                    :reduce="option=>option.id"
                                    :placeholder="getTranslation('selectFromList')"
                                    :options="statuses"
                            />
                        </td>
                        <th class="table-3__cell  table__hcell">
                            <button @click="fetchTestingQuestions(testingId)" class="btn  btn--sm  btn--main">{{getTranslation('search')}}</button>
                        </th>
                    </tr>
                    <tr class="table-3__row">
                        <th class="table-3__cell  table__hcell" style="width: 0.1%;">#</th>
                        <th class="table-3__cell  table__hcell" style="width: 30%;">{{ getTranslation('ru_RU') }}</th>
                        <th class="table-3__cell  table__hcell" style="width: 30%;">{{ getTranslation('ky_KG') }}</th>
                        <th class="table-3__cell  table__hcell" style="width: 10%;">{{ getTranslation('questionSection') }}</th>
                        <th class="table-3__cell  table__hcell" style="width: 18%;">{{ getTranslation('type') }}</th>
                        <th class="table-3__cell  table__hcell" style="width: 10%;">{{ getTranslation('status') }}</th>
                        <th class="table-3__cell  table__hcell" style="width: 0.2%;"></th>
                    </tr>
                </thead>
                <tbody class="table-3__body">
                    <tr v-for="(question,key) in  questions" class="table-3__row">
                        <td class="table-3__cell">
                            <strong>{{question.id}}</strong>
                        </td>
                        <td class="table-3__cell">
                            <router-link class="report-link" :to="{name:'api.question.get',params:{id:question.id},query:{testingId:testingId}}">
                                <MathJaxComponent v-if="question.type.slug === 'fill_in'" :formula="question.questionRu" />
                                <span v-if="question.type.slug !== 'fill_in'" v-html="question.questionRu"></span>
                            </router-link>
                        </td>
                        <td class="table-3__cell">
                            <router-link class="report-link" :to="{name:'api.question.get',params:{id:question.id},query:{testingId:testingId}}">
                                <MathJaxComponent v-if="question.type.slug === 'fill_in'" :formula="question.questionKy" />
                                <span v-if="question.type.slug !== 'fill_in'" v-html="question.questionKy"></span>
                            </router-link>
                        </td>
                        <td class="table-3__cell">
                            {{ question.section }} <span v-if="question.sectionKy">({{ question.sectionKy }})</span>
                        </td>
                        <td class="table-3__cell">
                            <span v-if="question.type">{{question.type.title}}</span>
                        </td>
                        <td class="table-3__cell">
                            {{question.statusTitle}}
                        </td>
                        <td class="table-3__cell">
                            <ActionsComponent
                                    :has-edit="hasPermission('api.question.update')"
                                    v-on:edit="editQuestion(question.id,testingId)" :has-delete="false"
                                    v-on:deactivate="deActivateQuestion(question.id,'deactivate')" :options="{deactivate:hasPermission('api.question.update') && question.status,activate:hasPermission('api.question.update') && !question.status}"
                                    v-on:activate="deActivateQuestion(question.id,'activate')"
                            />
                        </td>
                    
                    </tr>
                    <tr v-if="questions.length < 1" class="table-3__row">
                        <td colspan="5" class="table-3__cell empty">
                            {{ getTranslation('notAddedYet') }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- modal import -->
        <modal
                v-model="showModal"
                :modal-title="getTranslation('importQuestions')"
                :ok-button-label="getTranslation('import')"
                :cancel-button-label="getTranslation('cancel')"
                @ok-button-click="importQuestions"
                @cancelButtonClick="resetModal"
                @input="resetModal"
        >
            <form @submit.prevent="importQuestions" method="post" enctype="multipart/form-data" class="w-100">
                <a @click="importQuestions('empty')" class="btn btn--light btn--sm" href="javascript:void(0)">{{ getTranslation('downloadFileExample') }}</a>
                <a @click="importQuestions('filled')" class="btn btn--light btn--sm" href="javascript:void(0)">{{ getTranslation('downloadFilledFileExample') }}</a>
                <div class="form__group">
                    <label class="form__label  form__label--block" for="file">{{ getTranslation('chooseFile','.xls(x,m)') }}</label>
                    <input class="field field--full-width" ref="file" type="file" name="file" id="file">
                </div>
            </form>
        </modal>
    </section>
</template>

<script>
    
    import questionMixin from "../../questions/mixins/question";
    import MathJaxComponent from "@/components/MathJaxComponent";
    
    export default {
        name: "QuestionsComponent",
        components: { MathJaxComponent },
        mixins: [questionMixin],
        data() {
            return {
                questions: [],
                showModal: false,
            }
        },
        props: {
            testingId: {
                required: true,
            },
            active: {
                default: false
            }
        },
        watch: {
            'filterForm.status'() {
                this.fetchTestingQuestions( this.testingId );
            },
            'filterForm.typeId'() {
                this.fetchTestingQuestions( this.testingId );
            },
            'active'( val ) {
                if ( val )
                    this.fetchTestingQuestions( this.testingId );
            }
        },
        created() {
            
            this.fetchFormOptions().then( () => {
                this.loadSelects = true;
            } );
            
            if ( this.active )
                this.fetchTestingQuestions( this.testingId );
            
        },
        methods: {
            deActivateQuestion( id ,action='deactivate') {
                this.$snotify.confirm( action === 'deactivate' ? this.getTranslation( 'deactivateConfirmMsg' ) : this.getTranslation( 'activateConfirmMsg' ), {
                    showProgressBar: false,
                    closeOnClick: false,
                    backdrop: 0.5,
                    buttons: [
                        {
                            text: this.getTranslation( 'yes' ), action: ( toast ) => {
                                this.axios.put( this.$config.urls.question.fetchQuestion.url.replace( ':id', id ), { activation: action } ).then( () => {
                                    
                                    this.fetchTestingQuestions( this.testingId );
                        
                                    this.$snotify.remove( toast.id );
                                    setTimeout( () => {
                                        this.snotifySuccess( 'saveSuccessMsg' );
                                    } );
                                } );
                            }, bold: true
                        },
                        { text: this.getTranslation( 'no' ), action: ( toast ) => this.$snotify.remove( toast.id ) }
                    ]
                } );
            },
            importQuestions( type = null ) {
                
                if ( type ) {
                    
                    return this.axios.post( this.$config.urls.testing.importQuestions.url.replace( ':id', this.testingId ), formData, {
                        responseType: 'blob',
                        params: { example: type }
                    } ).then( response => {
                        const url = window.URL.createObjectURL( new Blob( [response.data] ) );
                        const link = document.createElement( 'a' );
                        link.href = url;
                        link.setAttribute( 'download', 'Пример файла.xlsx' );
                        document.body.appendChild( link );
                        link.click();
                    } );
                }
                
                let file = this.$refs.file.files[0];
                
                if ( !file )
                    return this.snotifyError( 'chooseFile', '.xls(x,m)' );
                
                let formData = new FormData();
                formData.append( 'file', file );
                
                if ( file.name.endsWith( '.xls' ) || file.name.endsWith( '.xlsx' ) || file.name.endsWith( '.xlsm' ) ) {
                    
                    
                    this.axios.post( this.$config.urls.testing.importQuestions.url.replace( ':id', this.testingId ), formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    } ).then( response => {
                        this.showModal = false;
                        this.fetchTestingQuestions( this.testingId );
                        this.snotifySuccess( 'saveSuccessMsg' );
                    } ).catch( () => {
                        this.showModal = false;
                    } );
                }
                else
                    return this.snotifyError( 'fileFormatErrorMsg', '.xls(x,m)' );
                
            },
            openImportModal() {
                this.showModal = true;
            },
            resetModal() {
            
            },
            resetFilter() {
                this.filterForm = {};
                this.fetchTestingQuestions( this.testingId );
            },
        }
        
    }
</script>

<style scoped>

</style>
